export const getActiveRouteName = (pathname, routes) => {
  // Strip query string / hash so labels are never derived from URL params.
  const cleanPathname = String(pathname || "").split(/[?#]/)[0];

  const matchedRoute = (routes || []).find(
    (route) =>
      cleanPathname === route.route ||
      cleanPathname.startsWith(`${route.route}/`),
  );

  // Preserve explicit entries (including empty names used to hide the label).
  if (matchedRoute) {
    return matchedRoute.name;
  }

  // Fallback: derive a short label from the path so every route shows a menu name.
  const segments = cleanPathname
    .split("/")
    .filter(Boolean)
    .filter((segment) => !/[=&]/.test(segment))
    .filter(
      (segment) =>
        segment.toLowerCase() !== "[object object]" &&
        segment.toLowerCase() !== "null" &&
        segment.toLowerCase() !== "undefined" &&
        !/%/.test(segment) &&
        !/\[object/i.test(segment),
    );

  let segment = "";
  for (let i = 0; i < segments.length; i += 1) {
    const current = segments[i];
    if (
      current &&
      !/^[0-9a-f]{8,}$/i.test(current) &&
      !/^\d+$/.test(current) &&
      current.length > 1
    ) {
      segment = current;
      break;
    }
  }

  if (!segment) return undefined;

  // Split hyphens, underscores and camelCase into separate words.
  const words = segment
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .split(/[-_\s]+/)
    .filter(Boolean);

  if (!words.length) return undefined;

  const toTitle = (word) =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

  return words.slice(0, 2).map(toTitle).join(" ");
};

export const getManagedShopId = (pathname) =>
  pathname.match(/^\/rawmaterial-newitem\/([^/]+)/)?.[1];

export const getManagedShopRouteName = (managedShop) => {
  const businessType = String(managedShop?.businessType || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  if (businessType === "retailershop") return "Retailer";
  if (businessType === "rawmaterialshop") return "Raw Material";
  if (businessType === "newshop") return "New Items";
  return null;
};